import { render, staticRenderFns } from "./VehiclesDataTable.vue?vue&type=template&id=871d630c&scoped=true"
import script from "./VehiclesDataTable.vue?vue&type=script&lang=js"
export * from "./VehiclesDataTable.vue?vue&type=script&lang=js"
import style0 from "./VehiclesDataTable.vue?vue&type=style&index=0&id=871d630c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871d630c",
  null
  
)

export default component.exports